// Кодмод Фазы 1 миграции на Vite (13.08.2026): require('*.png') → ESM-импорты.
// Vite не исполняет CommonJS в браузере ('require is not defined'); webpack
// понимает ESM-импорты ассетов так же (asset/resource → URL-строка).
import img0 from '@images/UI/Misc/yandex/red.png';
import img1 from '@images/UI/Misc/yandex/red@2x.png';
import img2 from '@images/UI/Misc/yandex/red@3x.png';
import img3 from '@images/UI/Misc/ya-market/colored.png';
import img4 from '@images/UI/Misc/ya-market/colored@2x.png';
import img5 from '@images/UI/Misc/ya-market/colored@3x.png';
import img6 from '@images/UI/Misc/bonusStar/red.png';
import img7 from '@images/UI/Misc/bonusStar/red@2x.png';
import img8 from '@images/UI/Misc/bonusStar/red@3x.png';
import img9 from '@images/UI/Misc/bonusStar/silver.png';
import img10 from '@images/UI/Misc/bonusStar/silver@2x.png';
import img11 from '@images/UI/Misc/bonusStar/silver@3x.png';
import img12 from '@images/UI/Misc/bonusStar/gold.png';
import img13 from '@images/UI/Misc/bonusStar/gold@2x.png';
import img14 from '@images/UI/Misc/bonusStar/gold@3x.png';
import img15 from '@images/UI/Misc/main-menu-mobile/menu-cart.png';
import img16 from '@images/UI/Misc/main-menu-mobile/menu-cart@2x.png';
import img17 from '@images/UI/Misc/main-menu-mobile/menu-cart@3x.png';
import img18 from '@images/UI/Misc/main-menu-mobile/menu-favorite.png';
import img19 from '@images/UI/Misc/main-menu-mobile/menu-favorite@2x.png';
import img20 from '@images/UI/Misc/main-menu-mobile/menu-favorite@3x.png';
import img21 from '@images/UI/Misc/main-menu-mobile/menu-coin.png';
import img22 from '@images/UI/Misc/main-menu-mobile/menu-coin@2x.png';
import img23 from '@images/UI/Misc/main-menu-mobile/menu-coin@3x.png';
import img24 from '@images/UI/Misc/main-menu-mobile/menu-cursor.png';
import img25 from '@images/UI/Misc/main-menu-mobile/menu-cursor@2x.png';
import img26 from '@images/UI/Misc/main-menu-mobile/menu-cursor@3x.png';
import img27 from '@images/UI/Misc/main-menu-mobile/menu-heart.png';
import img28 from '@images/UI/Misc/main-menu-mobile/menu-heart@2x.png';
import img29 from '@images/UI/Misc/main-menu-mobile/menu-heart@3x.png';
import img30 from '@images/UI/Misc/main-menu-mobile/menu-list.png';
import img31 from '@images/UI/Misc/main-menu-mobile/menu-list@2x.png';
import img32 from '@images/UI/Misc/main-menu-mobile/menu-list@3x.png';
import img33 from '@images/UI/Misc/main-menu-mobile/menu-phone.png';
import img34 from '@images/UI/Misc/main-menu-mobile/menu-phone@2x.png';
import img35 from '@images/UI/Misc/main-menu-mobile/menu-phone@3x.png';
import img36 from '@images/UI/Misc/main-menu-mobile/menu-qr.png';
import img37 from '@images/UI/Misc/main-menu-mobile/menu-qr@2x.png';
import img38 from '@images/UI/Misc/main-menu-mobile/menu-qr@3x.png';
import img39 from '@images/UI/Misc/main-menu-mobile/menu-question.png';
import img40 from '@images/UI/Misc/main-menu-mobile/menu-question@2x.png';
import img41 from '@images/UI/Misc/main-menu-mobile/menu-question@3x.png';

export default {
  Misc: {
    yandex: {
      red: {
        x1: img0,
        x2: img1,
        x3: img2
      }
    },
    yaMarket: {
      colored: {
        x1: img3,
        x2: img4,
        x3: img5
      }
    },
    bonusStar: {
      red: {
        x1: img6,
        x2: img7,
        x3: img8
      },
      silver: {
        x1: img9,
        x2: img10,
        x3: img11
      },
      gold: {
        x1: img12,
        x2: img13,
        x3: img14
      }
    },
    menuCart: {
      x1: img15,
      x2: img16,
      x3: img17
    },
    menuFavorite: {
      x1: img18,
      x2: img19,
      x3: img20
    },
    menuCoin: {
      x1: img21,
      x2: img22,
      x3: img23
    },
    menuCursor: {
      x1: img24,
      x2: img25,
      x3: img26
    },
    menuHeart: {
      x1: img27,
      x2: img28,
      x3: img29
    },
    menuList: {
      x1: img30,
      x2: img31,
      x3: img32
    },
    menuPhone: {
      x1: img33,
      x2: img34,
      x3: img35
    },
    menuQR: {
      x1: img36,
      x2: img37,
      x3: img38
    },
    menuQuestion: {
      x1: img39,
      x2: img40,
      x3: img41
    }
  }
};
